import { create } from 'zustand';
import { isoToJd } from '../lib/ephemeris';
import { useLayers } from './layersStore';
import { useTimeline } from './timelineStore';
import type { Scenario, ZoomLevel } from '../data/scenarios';

interface ScenarioState {
  /** Scénario en cours d'application — consommé par CameraDirector. */
  pendingZoom: ZoomLevel | null;
  applyScenario: (s: Scenario) => void;
  clearPending: () => void;
}

export const useScenario = create<ScenarioState>((set) => ({
  pendingZoom: null,
  applyScenario: (s) => {
    // 1. Date → timeline
    useTimeline.getState().set(isoToJd(s.date));
    // 2. Couches → layersStore
    const layersStore = useLayers.getState();
    Object.entries(s.layers).forEach(([k, v]) => {
      if (v !== undefined) layersStore.set(k as keyof typeof layersStore.active, v);
    });
    // 3. Pause + zoom pending
    if (useTimeline.getState().playing) useTimeline.getState().togglePlay();
    set({ pendingZoom: s.zoom });
  },
  clearPending: () => set({ pendingZoom: null }),
}));
